export const fireplaceTypes = [
    // { value: 'BH', text: 'Blockheizkraftwerk (BH)', fuel: ['gas', 'solid', 'liquid'] },
    { value: 'DW', text: 'Durchlaufwasserheizer (DW)', fuel: ['gas'] },
    { value: 'KW', text: 'Kombiwasserheizer (KW)', fuel: ['gas'] },
    // { value: 'WP', text: 'Wärmepumpe, Motor (WP)', fuel: ['gas', 'solid', 'liquid', 'electric'] },
    { value: 'HK', text: 'Heizkessel (HK)', fuel: ['gas', 'solid', 'liquid'] },
    { value: 'UW', text: 'Umlaufwasserheizer (UW)', fuel: ['gas'] },
    { value: 'VW', text: 'Vorratswasserheizer/Badeofen (VW)', fuel: ['gas'] },
    { value: 'WA', text: 'Wärmepumpe, Adsorption (WA)', fuel: ['gas'] },
    // { value: 'WT', text: 'Wäschetrockner (WT)', fuel: ['gas', 'electric'] },
    { value: 'LE', text: 'Lufterhitzer (LE)', fuel: ['gas', 'liquid'] },
    { value: 'SO', text: 'Speicherofen (SO)', fuel: ['solid'] },
    // { value: 'GO', text: 'Speicherofen - Grundofen (GO)', fuel: ['solid'] },
    // { value: 'SG', text: 'Speicherofen - Specksteingrundofen (SG)', fuel: ['solid'] },
    // { value: 'KH', text: 'Speicherofen - Kachelofen mit Heizeinsatz (KH)', fuel: ['solid'] },
    { value: 'KO', text: 'Kaminofen (KO)', fuel: ['solid'] },
    // { value: 'OK', text: 'Offener Kamin (OK)', fuel: ['solid'] },
    { value: 'KE', text: 'Kamineinsatz, Kaminkassette (KE)', fuel: ['solid'] },
    { value: 'RH', text: 'Raumheizer (RH)', fuel: ['solid', 'gas'] },
    { value: 'HE', text: 'Heizherd/Heizungsherd (HE)', fuel: ['solid'] },
    // { value: 'HK', text: 'Heizkessel (HK)', fuel: ['solid'] },
    // { value: 'FC', text: 'Brennstoffzelle (Fuel Cell) (FC)', fuel: ['liquid'] },
    // { value: 'BA', text: 'Backofen/Pizzaofen (BA)', fuel: ['electric'] },
    // { value: 'BO', text: 'Brennofen (BO)', fuel: ['electric'] },
    // { value: 'SD', text: 'Dunkelstrahler (SD)', fuel: ['electric'] },
    // { value: 'WM', text: 'Waschmaschine (WM)', fuel: ['electric'] },
    { value: 'MF', text: 'Mehrere Feuerstätten (MF)', fuel: ['solid', 'gas'] }
]
